import DashNav3 from "../components/DashNav3";
import '../styling/NewDash.css'
import clientimage from '../resources/clients.png'
import quoteimage from '../resources/tape.png'
import invoiceimage from '../resources/invoice.png'
import { useAuthContext } from "../hooks/useAuthContext";
import {useClientsContext} from "../hooks/useClientsContext"
import {useEffect, useState} from 'react'
import { useQuotesContext } from "../hooks/useQuotesContext";
import { useInvoiceContext } from "../hooks/useInvoiceContext";
import API_BASE_URL from '../config.js';


const NewDash = () => {
    const {user} = useAuthContext();
    const {clients, dispatch} = useClientsContext();
    const {quotes, dispatch: quotesdispatch} = useQuotesContext();

    const {calculateTotal, dispatch: invoiceDispatch} = useInvoiceContext();

    const[invoiceTotal, setInvoiceTotal] = useState('')


    useEffect(() => {
        const fetchClients = async () => {
    
            const response = await fetch(`${API_BASE_URL}/api/client`, {
                headers: {"Authorization": `Bearer ${user.token}`}
            })
    
            const json = await response.json()
    
            if(response.ok){
                dispatch({type: "SET_CLIENTS", payload:json})
            }     
        }
        if (user){
            fetchClients()
            console.log(clients);
        }
    // add clients to dependency below to update deleted client. 
      }, [dispatch,user])


    useEffect(() => {
        const fetchInvoices= async () => {
    
            const response = await fetch(`${API_BASE_URL}/api/invoice`, {
                headers: {"Authorization": `Bearer ${user.token}`}
            })
    
            const json = await response.json()
    
            if(response.ok){
                invoiceDispatch({type: "SET_INVOICES", payload:json})
                const total = calculateTotal() 
                setInvoiceTotal(total)
                console.log("invoice total:", invoiceTotal)
            }     
        }
        if (user){
            fetchInvoices()
            
        }
    // add clients to dependency below to update deleted client. 
      }, [invoiceDispatch,user,invoiceTotal])  

    
    useEffect(() => {
        const fetchQuotes = async () => {
    
            const response = await fetch(`${API_BASE_URL}/api/quote`, {
                headers: {"Authorization": `Bearer ${user.token}`}
            })
    
            const json = await response.json()
    
            if(response.ok){
                quotesdispatch({type: "SET_QUOTES", payload:json})
            }     
        }
        if (user){
            fetchQuotes()
        }  
    
    // add clients to dependency below to update deleted client. 
      }, [quotesdispatch,user])

    return ( 
        <div className="newdashcontainer">
            <DashNav3></DashNav3>
            <div className="newdashright">
                <div className="dashrighttop">
                <h1 className="text-3xl font-bold"> Hi, {user ? user.firstname + " ": " "} {user ? user.lastname: " "}!</h1>
                </div>
                <div className="dashrightstats">
                    <div className="stats1">
                        <div className="stats1box">
                        <img src={clientimage} alt="" />
                        </div>
                        <h1 className="text-xl text-white">Total Clients</h1>
                        {clients ? <h1 className="text-3xl text-white mt-3 font-bold">{clients.length} Clients</h1> : <h1 className="text-3xl text-white mt-3 font-bold">0 Clients</h1>}
                    </div>
                    <div className="stats2">
                        <div className="stats2box">
                        <img src={quoteimage} alt="" />
                        </div>
                        <h1 className="text-xl text-white">Total Quotes</h1>
                        {quotes ? <h1 className="text-3xl text-white mt-3 font-bold">{quotes.length} Quotes</h1> : <h1 className="text-3xl text-white mt-3 font-bold">0 Quotes</h1>}
                    </div>
                    <div className="stats3">
                        <div className="stats3box">
                        <img src={invoiceimage} alt="" />
                        </div>
                        <h1 className="text-xl text-white">Total Invoices</h1>
                        {invoiceTotal!=null ? <h1 className="text-3xl text-white mt-3 font-bold"> ${invoiceTotal}</h1> : <h1 className="text-3xl text-white mt-3 font-bold">$0</h1>}
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default NewDash;